import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { DatePicker } from "rsuite";

import PageTitle from "../../layouts/PageTitle";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  createAndUpdatePlayer,
  getBattingType,
  getBowlingType,
  getGender,
  getImageByFileName,
  getPackageType,
  getPlayerSubscription,
  uploadImage,
  uploadPlayerForm,
  uploadPlayerImage,
} from "../../../services/academicService";
import ImagePreviewModal from "../../components/ImagePreviewModal";
import {
  getPublicDiscountType,
  getPublicPaymentType,
  getPublicPlanType,
} from "../../../services/publicService";
import { formatDate } from "../../../utils/helperFunction";

const AddPlayer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editPlayer = location.state?.user || null;
  const pageRef = useRef(null); // container ref for DatePicker popups
  const [battingData, setBattingData] = useState([]);
  const [bowlingData, setBowlingData] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [selectedGender, setSelectedGender] = useState(null);
  const [selectedBatting, setSelectedBatting] = useState([]);
  const [selectedBowling, setSelectedBowling] = useState([]);
  const [packageData, setPackageData] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [uploadedImageFiles, setUploadedImageFiles] = useState(null);
  const [uploadedFormFiles, setUploadedFormFiles] = useState(null);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewFileName, setPreviewFileName] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [discountTypes, setDiscountTypes] = useState([]);
  const [planTypes, setPlanTypes] = useState([]);
  const [selectedDiscountType, setSelectedDiscountType] = useState(null);
  const [selectedPlanType, setSelectedPlanType] = useState(null);
  const [selectedDiscountApply, setSelectedDiscountApply] = useState({
    value: false,
    label: "No",
  });
  const [paymentMode, setPaymentMode] = useState([]);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    dob: null,
    sex: "",
    address: "",
    mobileNumber: "",
    email: "",
    schoolName: "",
    wicketKeeping: "",
    clubMember: "",
    parentName: "",
    joiningDate: null,
    amountDeposited: "",
    selectedPackage: "",
    receiptNo: "",
    dueDate: null,
    parentSignature: null,
    studentSignature: null,
    discountType: null,
    discountValueType: null,
    discountValue: 0,
  });

  useEffect(() => {
    if (editPlayer) {
      setFormData({
        name: editPlayer.name || "",
        dob: editPlayer.dob ? new Date(editPlayer.dob) : null,
        address: editPlayer.address || "",
        mobileNumber: editPlayer.phone || "",
        email: editPlayer.email || "",
        schoolName: editPlayer.schoolName || "",
        batting: editPlayer.batting || "",
        wicketKeeping: editPlayer.wicketKeeper ? "Yes" : "No",
        clubMember: editPlayer.memberOfOtherClub ? "Yes" : "No",
        parentName: editPlayer.parentName || "",
        joiningDate: editPlayer.dateOfJoining
          ? new Date(editPlayer.dateOfJoining)
          : null,
        dueDate: editPlayer?.dueDate ? new Date(editPlayer.dueDate) : null,
        amountDeposited: editPlayer.amountDeposited || "",
        receiptNo: editPlayer.receiptNumber || "",
        parentSignature: null,
        studentSignature: null,
      });
      setSelectedBatting(
        editPlayer.batting && Array.isArray(editPlayer.batting)
          ? editPlayer.batting.map((item) => ({ value: item, label: item }))
          : [],
      );
      setSelectedBowling(
        editPlayer.bowling && Array.isArray(editPlayer.bowling)
          ? editPlayer.bowling.map((item) => ({ value: item, label: item }))
          : [],
      );
      setSelectedGender(
        editPlayer.sex
          ? {
            value: editPlayer.sex,
            label: editPlayer.sex,
          }
          : null,
      );
      setSelectedPackage(
        editPlayer?.subscription
          ? {
            value: editPlayer?.subscription?.id,
            label: `${editPlayer?.subscription?.packageType?.name} (Amount : ${editPlayer?.subscription?.ammount} INR)`,
          }
          : null,
      );
      setUploadedFormFiles(editPlayer.playerForm || null);
      setUploadedImageFiles(editPlayer.playerImage || null);
    }
  }, [editPlayer]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSelectChange = (name, option) => {
    setFormData({ ...formData, [name]: option?.value || "" });
    setErrors({ ...errors, [name]: "" });
  };

  const handleDateChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleImageFileChange = async (e) => {
    try {
      const file = e.target.files[0]; //single file
      if (!file) return;

      //Upload to API
      const res = await uploadPlayerImage(file);

      //REPLACE instead of append
      setUploadedImageFiles(res);
    } catch (error) {
      console.error("Image upload failed:", error);
    }
  };

  const handleFormFileChange = async (e) => {
    try {
      const file = e.target.files[0]; //single file
      if (!file) return;

      //Upload to API
      const res = await uploadPlayerForm(file);

      //REPLACE instead of append
      setUploadedFormFiles(res);
    } catch (error) {
      console.error("Image upload failed:", error);
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.dob) newErrors.dob = "Date of Birth is required";
    if (!selectedGender) newErrors.gender = "Gender is required";

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(formData.email)
    ) {
      newErrors.email = "Invalid email format";
    }

    if (!formData.mobileNumber.trim()) {
      newErrors.mobileNumber = "Mobile Number is required";
    }
    if (!formData.address.trim()) newErrors.address = "Address is required";

    // Proficiency
    if (selectedBatting.length === 0)
      newErrors.batting = "Batting style is required";
    if (selectedBowling.length === 0)
      newErrors.bowling = "Bowling type is required";
    if (!formData.wicketKeeping)
      newErrors.wicketKeeping = "Wicket Keeping selection is required";
    if (!formData.clubMember)
      newErrors.clubMember = "Please select if member of other club";
    if (!formData.parentName.trim())
      newErrors.parentName = "Parent Name is required";

    // // Membership
    if (!editPlayer?.id) {
      if (!selectedPackage) newErrors.package = "Package is required";

      if (!formData.joiningDate)
        newErrors.joiningDate = "Date of Joining is required";
      if (!selectedPaymentMode)
        newErrors.paymentMode = "Payment Mode is required";
      if (!formData.amountDeposited)
        newErrors.amountDeposited = "Amount Deposited is required";
      if (!formData.receiptNo.trim())
        newErrors.receiptNo = "Receipt Number is required";
      if (selectedDiscountApply === null)
        newErrors.selectedDiscountApply = "Discount apply field required";
      if (selectedDiscountApply?.value === true) {
        if (!selectedDiscountType)
          newErrors.discountTypes = "Discount type required";

        if (!formData.discountValue)
          newErrors.discountValue = "Discount required";

        if (!selectedPlanType)
          newErrors.discountValueTypes = "Plan type required";
      }
    }
    console.log("validation errors", newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;
    // // Upload Player Image
    // let playerImageUrl = editPlayer?.playerImage || null;
    // if (formData.parentSignature) {
    //   const imgRes = await uploadPlayerImage(formData.parentSignature);
    //   playerImageUrl = imgRes?.url || imgRes;
    // }

    // // Upload Player Form
    // let playerFormUrl = editPlayer?.playerForm || null;
    // if (formData.studentSignature) {
    //   const formRes = await uploadPlayerForm(formData.studentSignature);
    //   playerFormUrl = formRes?.url || formRes;
    // }

    // let playerImageUrl = editPlayer?.playerImage || null;
    // let playerFormUrl = editPlayer?.playerForm || null;

    // // Upload only if user selects a NEW file
    // if (formData.parentSignature instanceof File) {
    //   const imgRes = await uploadPlayerImage(formData.parentSignature);
    //   playerImageUrl = imgRes?.url || imgRes;
    // }

    // if (formData.studentSignature instanceof File) {
    //   const formRes = await uploadPlayerForm(formData.studentSignature);
    //   playerFormUrl = formRes?.url || formRes;
    // }

    setLoading(true);
    const payload = {
      id: editPlayer?.id || undefined,

      // BASIC INFO
      name: formData.name,
      dob: formData.dob ? formatDate(formData.dob) : null,
      sex: selectedGender?.value || "",
      address: formData.address,
      phone: formData.mobileNumber,
      email: formData.email,

      // proficiency
      batting: selectedBatting ? selectedBatting.map((item) => item.value) : [],
      bowling: selectedBowling ? selectedBowling.map((item) => item.value) : [],
      wicketKeeper: formData.wicketKeeping === "Yes",
      memberOfOtherClub: formData.clubMember === "Yes",
      parentName: formData.parentName,

      //MEMBERSHIP
      ...(!editPlayer?.id && {
        packageId: selectedPackage?.value || "",
        dateOfJoining: formData.joiningDate
          ? formatDate(formData.joiningDate)
          : null,
        paymentMode: selectedPaymentMode?.value || "",
        amountDeposited: formData.amountDeposited
          ? parseInt(formData.amountDeposited, 10)
          : 0,
        receiptNumber: formData.receiptNo,
        dueDate: formData.dueDate //ADD
          ? formatDate(formData.dueDate)
          : null,
        isDiscount: selectedDiscountApply?.value || false,
        ...(selectedDiscountApply?.value && {
          discountType: selectedPlanType?.value || null,
          discountValueType: selectedDiscountType?.value || null,
          discountValue: Number(formData.discountValue),
        }),
      }),
      // FILES
      playerImage: uploadedImageFiles,
      playerForm: uploadedFormFiles,
    };

    try {
      const res = await createAndUpdatePlayer(payload);

      if (res) {
        toast.success(
          editPlayer
            ? "Player updated successfully!"
            : "Player created successfully!",
          { position: "top-right", autoClose: 1000 },
        );
      }

      navigate("/admin/all-players");
    } catch (error) {
      const apiMessage =
        error?.response?.data?.errorMessage ||
        "An error occurred while saving the player.";

      toast.error(apiMessage, {
        position: "top-right",
        autoClose: 1000,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBattingData();
    fetchPaymentModes();
  }, []);

  async function fetchPaymentModes() {
    try {
      const res = await getPublicPaymentType();
      setPaymentMode(res);
    } catch (error) {
      console.error("Error fetching payment modes:", error);
    }
  }

  async function fetchBattingData() {
    try {
      const res = await getBattingType();
      setBattingData(res);
    } catch (error) {
      console.error("Error fetching coach skills:", error);
    }
  }

  useEffect(() => {
    fetchBowlingData();
  }, []);

  async function fetchBowlingData() {
    try {
      const res = await getBowlingType();
      setBowlingData(res);
    } catch (error) {
      console.error("Error fetching coach skills:", error);
    }
  }

  useEffect(() => {
    fetchGender();
  }, []);

  async function fetchGender() {
    try {
      const res = await getGender();
      setGenderData(res);
    } catch (error) {
      console.error("Error fetching coach skills:", error);
    }
  }

  useEffect(() => {
    fetchPackage();
  }, []);

  async function fetchPackage() {
    try {
      const res = await getPlayerSubscription();
      setPackageData(res);
    } catch (error) {
      console.error("Error fetching package types:", error);
    }
  }

  useEffect(() => {
    fetchDiscountTypes();
    fetchPlanTypes();
  }, []);

  async function fetchDiscountTypes() {
    try {
      const res = await getPublicDiscountType();
      setDiscountTypes(res);
    } catch (error) {
      console.error("Error fetching discount types:", error);
    }
  }

  async function fetchPlanTypes() {
    try {
      const res = await getPublicPlanType();
      setPlanTypes(res);
    } catch (error) {
      console.error("Error fetching plan types:", error);
    }
  }

  useEffect(() => {
    if (!selectedPackage) return;

    const pkg = packageData.find((item) => item.id === selectedPackage.value);

    const packageAmount = Number(pkg?.ammount || 0);
    const discountValue = Number(formData.discountValue || 0);

    let discountAmount = 0;

    if (selectedDiscountType?.value === "PERCENTAGE") {
      // Allow only 1-100%
      const percentage = Math.min(Math.max(discountValue, 0), 100);

      discountAmount = (packageAmount * percentage) / 100;
    } else {
      // Fixed amount
      discountAmount = discountValue;
    }

    const finalAmount = Math.max(packageAmount - discountAmount, 0);

    setFormData((prev) => ({
      ...prev,
      amountDeposited: finalAmount,
    }));
  }, [
    selectedPackage,
    formData.discountValue,
    selectedDiscountType,
    packageData,
  ]);

  return (
    <div ref={pageRef}>
      {/* <PageTitle activeMenu={"Add Players"} motherMenu={"Players"} /> */}
      <div className="page-titles d-flex justify-content-between align-items-center">
        <h4 className="mb-0">{editPlayer ? "Edit" : "Add"} Player</h4>
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item ">
            <Link to="/admin/all-players">Players</Link>
          </li>
          <li className="breadcrumb-item active">
            <Link> {editPlayer ? "Edit" : "Add"} Player</Link>
          </li>
        </ol>
      </div>
      <div className="row">
        <div className="col-xl-12 col-xxl-12 col-sm-12">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Player Registration</h5>
            </div>
            <div className="card-body">
              <form>
                <div className="row">
                  {/* Name of the Student */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="name">
                        Name of the player{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        id="name"
                        placeholder="Enter Full Name"
                        type="text"
                        name="name"
                        className={`form-control ${errors.name ? "is-invalid" : ""
                          }`}
                        value={formData.name}
                        onChange={handleChange}
                      />
                      {errors.name && (
                        <div className="text-danger m-lg-2">{errors.name}</div>
                      )}
                    </div>
                  </div>

                  {/* Date of Birth */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="dob">
                        Date of Birth <span className="text-danger">*</span>
                      </label>
                      <div className="input-hasicon mb-xl-0 mb-3">
                        <DatePicker
                          placeholder="Select Date of Birth"
                          className="picker-suit"
                          value={formData.dob}
                          onChange={(val) => handleDateChange("dob", val)}
                          container={() => pageRef.current}
                          placement="auto"
                          format="dd-MM-yyyy"
                          editable
                          oneTap={false}
                        />
                        <div className="icon">
                          <i className="far fa-calendar" />
                        </div>
                      </div>
                      {errors.dob && (
                        <div className="text-danger m-lg-2">{errors.dob}</div>
                      )}
                    </div>
                  </div>

                  {/* Sex */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label">
                        Gender <span className="text-danger">*</span>
                      </label>
                      <Select
                        isSearchable={false}
                        options={genderData}
                        placeholder="Select Gender"
                        className="custom-react-select"
                        value={selectedGender}
                        onChange={setSelectedGender}
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: errors.gender
                              ? "#FF1616"
                              : base.borderColor,
                            boxShadow: errors.gender
                              ? "0 0 0 1px #FF1616"
                              : base.boxShadow,
                            "&:hover": {
                              borderColor: errors.gender
                                ? "#FF1616"
                                : base.borderColor,
                            },
                          }),
                        }}
                      />
                      {errors.gender && (
                        <div className="text-danger m-lg-2">
                          {errors.gender}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Package */}
                  {!editPlayer?.id && (
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label">
                          Package <span className="text-danger">*</span>
                        </label>
                        <Select
                          isSearchable={false}
                          options={packageData?.map((pkg) => ({
                            value: pkg?.id,
                            label: `${pkg?.packageType?.name} (Amount : ${pkg?.ammount} INR)`,
                          }))}
                          placeholder="Select Package"
                          className="custom-react-select"
                          value={selectedPackage}
                          onChange={setSelectedPackage}
                          styles={{
                            control: (base) => ({
                              ...base,
                              borderColor: errors.package
                                ? "#FF1616"
                                : base.borderColor,
                              boxShadow: errors.package
                                ? "0 0 0 1px #FF1616"
                                : base.boxShadow,
                              "&:hover": {
                                borderColor: errors.package
                                  ? "#FF1616"
                                  : base.borderColor,
                              },
                            }),
                          }}
                        />
                        {errors.package && (
                          <div className="text-danger m-lg-2">
                            {errors.package}
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Email */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="email">
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        id="email"
                        name="email"
                        placeholder="Enter Email"
                        type="email"
                        className={`form-control ${errors.email ? "is-invalid" : ""
                          }`}
                        value={formData.email}
                        onChange={handleChange}
                        readonly={editPlayer?.id}
                      />
                      {errors.email && (
                        <div className="text-danger m-lg-2">{errors.email}</div>
                      )}
                    </div>
                  </div>

                  {/* Mobile Number */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="mobileNumber">
                        Mobile Number <span className="text-danger">*</span>
                      </label>
                      <input
                        id="mobileNumber"
                        name="mobileNumber"
                        placeholder="Enter Mobile Number"
                        type="number"
                        className={`form-control ${errors.mobileNumber ? "is-invalid" : ""
                          }`}
                        value={formData.mobileNumber}
                        onChange={handleChange}
                      />
                      {errors.mobileNumber && (
                        <div className="text-danger m-lg-2">
                          {errors.mobileNumber}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Address */}
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="form-group">
                      <label className="form-label" htmlFor="address">
                        Address <span className="text-danger">*</span>
                      </label>
                      <textarea
                        id="address"
                        name="address"
                        placeholder="Enter Address"
                        className={`form-control ${errors.address ? "is-invalid" : ""
                          }`}
                        rows="3"
                        value={formData.address}
                        onChange={handleChange}
                      />
                      {errors.address && (
                        <div className="text-danger m-lg-2">
                          {errors.address}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Proficiency Section */}
                  <div className="col-lg-12">
                    <h6 className="mt-3">Proficiency</h6>
                  </div>

                  {/* Batting */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label">
                        Batting <span className="text-danger">*</span>
                      </label>
                      <Select
                        isSearchable={false}
                        isMulti
                        options={battingData}
                        placeholder="Select Batting Style"
                        className="custom-react-select"
                        value={selectedBatting}
                        onChange={setSelectedBatting}
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: errors.batting
                              ? "#FF1616"
                              : base.borderColor,
                            boxShadow: errors.batting
                              ? "0 0 0 1px #FF1616"
                              : base.boxShadow,
                            "&:hover": {
                              borderColor: errors.batting
                                ? "#FF1616"
                                : base.borderColor,
                            },
                          }),
                        }}
                      />
                      {errors.batting && (
                        <div className="text-danger m-lg-2">
                          {errors.batting}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Bowling */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label">
                        Bowling <span className="text-danger">*</span>
                      </label>
                      <Select
                        isSearchable={false}
                        isMulti
                        options={bowlingData}
                        placeholder="Select Bowling Type"
                        className="custom-react-select"
                        value={selectedBowling}
                        onChange={setSelectedBowling}
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: errors.bowling
                              ? "#FF1616"
                              : base.borderColor,
                            boxShadow: errors.bowling
                              ? "0 0 0 1px #FF1616"
                              : base.boxShadow,
                            "&:hover": {
                              borderColor: errors.bowling
                                ? "#FF1616"
                                : base.borderColor,
                            },
                          }),
                        }}
                      />
                      {errors.bowling && (
                        <div className="text-danger m-lg-2">
                          {errors.bowling}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Wicket Keeping */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label">
                        Wicket Keeping <span className="text-danger">*</span>
                      </label>
                      <Select
                        isSearchable={false}
                        options={[
                          { value: "Yes", label: "Yes" },
                          { value: "No", label: "No" },
                        ]}
                        placeholder="Do you keep wickets?"
                        className="custom-react-select"
                        value={
                          formData.wicketKeeping
                            ? {
                              value: formData.wicketKeeping,
                              label: formData.wicketKeeping,
                            }
                            : null
                        }
                        onChange={(opt) =>
                          handleSelectChange("wicketKeeping", opt)
                        }
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: errors.wicketKeeping
                              ? "#FF1616"
                              : base.borderColor,
                            boxShadow: errors.wicketKeeping
                              ? "0 0 0 1px #FF1616"
                              : base.boxShadow,
                            "&:hover": {
                              borderColor: errors.wicketKeeping
                                ? "#FF1616"
                                : base.borderColor,
                            },
                          }),
                        }}
                      />
                      {errors.wicketKeeping && (
                        <div className="text-danger m-lg-2">
                          {errors.wicketKeeping}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Member of any club */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label">
                        Member of Any Other Club{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Select
                        isSearchable={false}
                        options={[
                          { value: "Yes", label: "Yes" },
                          { value: "No", label: "No" },
                        ]}
                        placeholder="Select"
                        className="custom-react-select"
                        value={
                          formData.clubMember
                            ? {
                              value: formData.clubMember,
                              label: formData.clubMember,
                            }
                            : null
                        }
                        onChange={(opt) =>
                          handleSelectChange("clubMember", opt)
                        }
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: errors.clubMember
                              ? "#FF1616"
                              : base.borderColor,
                            boxShadow: errors.clubMember
                              ? "0 0 0 1px #FF1616"
                              : base.boxShadow,
                            "&:hover": {
                              borderColor: errors.clubMember
                                ? "#FF1616"
                                : base.borderColor,
                            },
                          }),
                        }}
                      />
                      {errors.clubMember && (
                        <div className="text-danger m-lg-2">
                          {errors.clubMember}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Parent Name */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="parentName">
                        Parent Name <span className="text-danger">*</span>
                      </label>
                      <input
                        id="parentName"
                        name="parentName"
                        placeholder="Enter Parent Name"
                        type="text"
                        className={`form-control ${errors.parentName ? "is-invalid" : ""
                          }`}
                        value={formData.parentName}
                        onChange={handleChange}
                      />
                      {errors.parentName && (
                        <div className="text-danger m-lg-2">
                          {errors.parentName}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Parent Signature Upload */}
                  <div className="col-sm-6">
                    <div className="form-group fallback w-100">
                      <label className="form-label">Player Image </label>
                      <input
                        id="parentSignature"
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={handleImageFileChange}
                      />
                    </div>
                  </div>

                  {/* Student Signature Upload */}
                  <div className="col-sm-6">
                    <div className="form-group fallback w-100">
                      <label className="form-label">Player Form</label>
                      <input
                        id="studentSignature"
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={handleFormFileChange}
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 flex-row d-flex gap-4">
                    {uploadedImageFiles && (
                      <div className="col-sm-6">
                        <h6>Image File</h6>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                          }}
                        >
                          <div className="d-flex align-items-center justify-content-between p-2 border rounded">
                            {/* File Name on the Left */}
                            <div
                              style={{
                                flex: 1,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {uploadedImageFiles?.fileName}
                            </div>

                            {/* Action Buttons on the Right */}
                            <div className="d-flex align-items-center gap-2">
                              <button
                                type="button"
                                className="btn btn-secondary btn-sm"
                                title="View"
                                onClick={() => {
                                  setPreviewFileName(
                                    uploadedImageFiles.fileName,
                                  );
                                  setPreviewModal(true);
                                }}
                              >
                                <i className="fa fa-eye" />
                              </button>
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                title="Delete"
                                onClick={() => setUploadedImageFiles(null)}
                              >
                                <i className="fa fa-trash" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {uploadedFormFiles && (
                      <div className="col-sm-6">
                        <h6>Form File</h6>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                          }}
                        >
                          <div className="d-flex align-items-center justify-content-between p-2 border rounded">
                            {/* File Name on the Left */}
                            <div
                              style={{
                                flex: 1,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {uploadedFormFiles?.fileName}
                            </div>

                            {/* Action Buttons on the Right */}
                            <div className="d-flex align-items-center gap-2">
                              <button
                                type="button"
                                className="btn btn-secondary btn-sm"
                                title="View"
                                onClick={() => {
                                  setPreviewFileName(
                                    uploadedFormFiles.fileName,
                                  );
                                  setPreviewModal(true);
                                }}
                              >
                                <i className="fa fa-eye" />
                              </button>
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                title="Delete"
                                onClick={() => setUploadedFormFiles(null)}
                              >
                                <i className="fa fa-trash" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {!editPlayer?.id && (
                    <>
                      <div className="col-lg-12">
                        <h6 className="mt-3">Membership</h6>
                      </div>

                      {/* Date of Joining */}
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className="form-label" htmlFor="joiningDate">
                            Date of Joining{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="input-hasicon mb-xl-0 mb-3">
                            <DatePicker
                              placeholder="Select Date"
                              className="picker-suit"
                              value={formData.joiningDate}
                              onChange={(val) =>
                                handleDateChange("joiningDate", val)
                              }
                              container={() => pageRef.current}
                              placement="auto"
                              format="dd-MM-yyyy"
                              editable
                              oneTap={false}
                            />
                            <div className="icon">
                              <i className="far fa-calendar" />
                            </div>
                          </div>
                          {errors.joiningDate && (
                            <div className="text-danger m-lg-2">
                              {errors.joiningDate}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Selected Package */}
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className="form-label"
                            htmlFor="selectedPackage"
                          >
                            Selected Package{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            id="selectedPackage"
                            placeholder="e.g. Annually"
                            type="text"
                            className={`form-control ${errors.selectedPackage ? "is-invalid" : ""
                              }`}
                            value={selectedPackage?.label}
                            readOnly
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className="form-label">
                            Payment Mode <span className="text-danger">*</span>
                          </label>
                          <Select
                            isSearchable={false}
                            options={paymentMode?.map((mode) => ({
                              value: mode?.value,
                              label: mode?.label,
                            }))}
                            placeholder="Select Payment Mode"
                            className="custom-react-select"
                            value={selectedPaymentMode}
                            onChange={setSelectedPaymentMode}
                          />
                          {errors.paymentMode && (
                            <div className="text-danger m-lg-2">
                              {errors.paymentMode}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Amount Deposited */}
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className="form-label"
                            htmlFor="amountDeposited"
                          >
                            Amount Deposited{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            id="amountDeposited"
                            name="amountDeposited"
                            placeholder="Enter Amount"
                            type="number"
                            className={`form-control ${errors.amountDeposited ? "is-invalid" : ""
                              }`}
                            value={formData.amountDeposited}
                            onChange={handleChange}
                          />
                          {errors.amountDeposited && (
                            <div className="text-danger m-lg-2">
                              {errors.amountDeposited}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className="form-label">
                            Discount Apply<span className="text-danger">*</span>
                          </label>
                          <Select
                            isSearchable={false}
                            options={[
                              { value: true, label: "Yes" },
                              { value: false, label: "No" },
                            ]}
                            placeholder="Select Discount"
                            className="custom-react-select"
                            value={selectedDiscountApply}
                            onChange={(value) => {
                              setSelectedDiscountApply(value);
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                selectedDiscountApply: undefined,
                              }));
                            }}
                          />
                          {errors.selectedDiscountApply && (
                            <div className="text-danger m-lg-2">
                              {errors.selectedDiscountApply}
                            </div>
                          )}
                        </div>
                      </div>
                      {selectedDiscountApply.value === true && (
                        <>
                          {/*  Discount Type */}
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label className="form-label">
                                Discount Type{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <Select
                                isSearchable={false}
                                options={discountTypes?.map((mode) => ({
                                  value: mode?.value,
                                  label: mode?.label,
                                }))}
                                placeholder="Select Discount Type"
                                className="custom-react-select"
                                value={selectedDiscountType}
                                onChange={(value) => {
                                  setSelectedDiscountType(value);
                                  setErrors((prevErrors) => ({
                                    ...prevErrors,
                                    discountTypes: undefined,
                                  }));
                                }}
                              />
                              {errors.discountTypes && (
                                <div className="text-danger m-lg-2">
                                  {errors.discountTypes}
                                </div>
                              )}
                            </div>
                          </div>

                          {/*  Discount */}
                          <div className="col-sm-6 mb-3">
                            <label className="form-label">
                              Discount <span className="text-danger">*</span>
                            </label>
                            <input
                              type="number"
                              name="discountValue"
                              placeholder={
                                selectedDiscountType?.value === "PERCENTAGE"
                                  ? "Enter percentage (1-100)"
                                  : "Enter discount amount"
                              }
                              className="form-control"
                              value={formData.discountValue}
                              onChange={handleChange}
                            />
                            {errors.discountValue && (
                              <div className="text-danger m-lg-2">
                                {errors.discountValue}
                              </div>
                            )}
                          </div>

                          {/*  Discount Limitation */}
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label className="form-label">
                                Plan Type <span className="text-danger">*</span>
                              </label>
                              <Select
                                isSearchable={false}
                                options={planTypes?.map((mode) => ({
                                  value: mode?.value,
                                  label: mode?.label,
                                }))}
                                placeholder="Select Plan Type"
                                className="custom-react-select"
                                value={selectedPlanType}
                                onChange={(value) => {
                                  setSelectedPlanType(value);
                                  setErrors((prevErrors) => ({
                                    ...prevErrors,
                                    discountValueTypes: undefined,
                                  }));
                                }}
                              />
                              {errors.discountValueTypes && (
                                <div className="text-danger m-lg-2">
                                  {errors.discountValueTypes}
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}

                      {/* Receipt No */}
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className="form-label" htmlFor="receiptNo">
                            Receipt No. <span className="text-danger">*</span>
                          </label>
                          <input
                            id="receiptNo"
                            placeholder="Enter Receipt Number"
                            type="text"
                            className={`form-control ${errors.receiptNo ? "is-invalid" : ""
                              }`}
                            name="receiptNo"
                            value={formData.receiptNo}
                            onChange={handleChange}
                          />
                          {errors.receiptNo && (
                            <div className="text-danger m-lg-2">
                              {errors.receiptNo}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Due Date */}
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className="form-label" htmlFor="dueDate">
                            Due Date
                          </label>

                          <div className="input-hasicon mb-xl-0 mb-3">
                            <DatePicker
                              placeholder="Select Due Date"
                              className="picker-suit"
                              value={formData.dueDate}
                              onChange={(val) =>
                                handleDateChange("dueDate", val)
                              }
                              container={() => pageRef.current}
                              placement="auto"
                              format="dd-MM-yyyy"
                              editable
                              oneTap={false}
                            />
                            <div className="icon">
                              <i className="far fa-calendar" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {/* Submit */}
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <button
                      type="button"
                      onClick={handleSubmit}
                      className="btn btn-primary me-1"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                    <Link
                      to="/admin/all-players"
                      className="btn btn-danger light"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <ImagePreviewModal
        show={previewModal}
        onClose={() => setPreviewModal(false)}
        fileName={previewFileName}
      />
    </div>
  );
};

export default AddPlayer;